import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class GestaoRequisitarCartoesDetailsService {

  constructor(
    private http: HttpService,
  ) { }

  buscaOnboardById(path:any, successHandle:Function, errorHandle:Function) {

    return this.http.doGet('/card/request/situation/'+path, null, successHandle, errorHandle);
  }

  buscaOnboardLog(pathId:any, pathEtapa: any, params:any, successHandle:Function, errorHandle:Function) {

    return this.http.doGet('/card/request/situation/'+ pathId +"/step/" + pathEtapa, params, successHandle, errorHandle);
  }

  reprocess(pathId:any, pathEtapa: any, params:any, successHandle:Function, errorHandle:Function) {

    return this.http.doGet('/card/request/situation/'+ pathId +"/step/" + pathEtapa + "/reprocess", params, successHandle, errorHandle);
  }

}
